import { useCallback, useState } from 'react'

export function useToggle(initialValue = false) {
    const [value, setValue] = useState(initialValue)

    const onToggle = useCallback(() => {
        setValue((prev) => !prev)
    }, [])

    return { value, onToggle }
}
